<script>
/**
 * Sales Analytics component
 */
export default {
  props: {
    mode: {
      type: String,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 230,
          type: "donut",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: ["#5664d2", "#1cbb8c", "#eeb902"],
      },
    }
  },
  computed: {
    chartData() {
      const chartData = {
        daily: {
          series: [],
          labels: [],
          total: null
        },
        weekly: {
          series: [],
          labels: [],
          total: null
        },
        monthly: {
          series: [],
          labels: [],
          total: null
        },
      }
      if (this.data) {
        if (this.data.daily_payment_method) {
          chartData.daily.series = this.data.daily_payment_method.map(
            (element) => element.count
          )
          chartData.daily.labels = this.data.daily_payment_method.map(
            (element) => element.label
          )
          chartData.daily.total = this.data.daily_payment_method.reduce(
            (inc, element) => inc + element.count, 0
          )
        }
        if (this.data.weekly_payment_method) {
          chartData.weekly.series = this.data.weekly_payment_method.map(
            (element) => element.count
          )
          chartData.weekly.labels = this.data.weekly_payment_method.map(
            (element) => element.label
          )
          chartData.weekly.total = this.data.weekly_payment_method.reduce(
            (inc, element) => inc + element.count, 0
          )
        }
        if (this.data.monthly_payment_method) {
          chartData.monthly.series = this.data.monthly_payment_method.map(
            (element) => element.count
          )
          chartData.monthly.labels = this.data.monthly_payment_method.map(
            (element) => element.label
          )
          chartData.monthly.total = this.data.monthly_payment_method.reduce(
            (inc, element) => inc + element.count, 0
          )
        }
      }
      return chartData
    },
  },
  methods: {
    getDiffPercentage(value1, value2) {
      return ((value1 / value2) * 100).toFixed(2)
    },
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <!-- <h4 class="card-title mb-4">(.*)</h4> -->

      <div id="donut-chart" class="apex-charts"></div>
      <apexchart
        class="apex-charts"
        height="230"
        dir="ltr"
        :series="chartData[mode].series"
        :options="{
          ...chartOptions,
          labels: chartData[mode].labels,
        }"
      ></apexchart>
      <div class="row">
        <div class="col" v-for="(label, index) in chartData[mode].labels" :key="index">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate">
              <i class="mdi mdi-circle font-size-10 mr-1" :style="`color: ${chartOptions.colors[index]};`"></i>
              {{ label }}
            </p>
            <h5>{{ getDiffPercentage(chartData[mode].series[index], chartData[mode].total) }} %</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>